export default __webpack_public_path__ + "static/media/element_56.709d96da.jpg";